import { Component } from '@angular/core';

@Component({
  selector: 'hb-day-trades-info',
  template: `<h2>Day trades</h2>

    <p>
      Un day trade es cuando compras y vendes o vendes y compras la misma
      emisora en un solo día
    </p>

    <h3>¿Cómo funciona?</h3>

    <p>
      Lo puedes realizar 3 veces durante 5 días hábiles con acciones de la misma
      empresa o 3 diferentes (el período empieza a contar desde que haces el
      primer day trade, sin importar el día de la semana)
    </p>
    <p>
      Ej: Compras y vendes acciones de Apple el martes, Amazon el miércoles y
      otra vez Apple el jueves, tendrás que esperar al siguiente martes para
      volver a realizar un day trade
    </p>

    <!-- -------------- Uncomment when we have a TUSA FAQ in prod -------------- -->
    <button *ngIf="false" class="link link--semibold">
      ¿Quieres saber más?
    </button>`,
})
export class DayTradesInfoComponent {}
